import { Dispatch } from "redux";
import { RemoveChoicePayload } from "../../actions/choiceActions";
import { RootState } from "../../reducers";
import conditionsEffectRouter from "./conditionsRouter";

const removeChoiceSideEffects = (
  { id }: RemoveChoicePayload,
  state: RootState,
  dispatch: Dispatch
) => {
  const part = state.formData.entities.parts.byId[id];
  if (!part) return;

  part.conditions.forEach((conditionId) => {
    const condition = state.formData.entities.conditions.byId[conditionId];
    if (!condition) return;

    conditionsEffectRouter("remove")[condition.should](
      condition,
      state,
      dispatch
    );
  });
};

export default removeChoiceSideEffects;
